// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4a45b02f","455":"cb467061","977":"94da116e"}[chunkId] + ".chunk.js";
};